import {mapActions} from "vuex";

export default {
    methods: {
        ...mapActions({
            showPopUp: "pop_up/showPopUp",
            removePopUp : "pop_up/removePopUp"
        })
    },
}